import { useCallback, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import { Optional } from 'packages/types'
import EditorField from 'builder/components/EditorField'
import { TextField } from 'builder/components/TextField'
import { useI18n } from 'builder/hooks/useI18n'
import { actions as editorActions } from 'builder/modules/resumeEditor'

type Props = {
  firstName: Optional<string>
}

export const FirstName = (props: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { firstName } = props

  const handleSimpleFieldUpdate = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target
      dispatch(editorActions.updateSimpleField({ name: 'firstName', value, debounce: true }))
    },
    [dispatch],
  )

  return (
    <>
      {/* First name */}
      <EditorField>
        <TextField
          label={i18n.t('builder.resume_editor.first_name')}
          value={firstName || ''}
          name="firstName"
          onChange={handleSimpleFieldUpdate}
        />
      </EditorField>
    </>
  )
}
